<template>
  <div>
    <v-divider></v-divider>
    <v-layout wrap fill-height>
      <v-flex class="sidebar-slot">
        <AppSidebar :items="sarpadashboard" v-model="sideNav" />
      </v-flex>
      <v-flex class="main-content-flex">
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <SarpaAppHeader class="pb-0 mb-0" @toggle-nav="sideNav = !sideNav" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0><v-divider class="pt-0 mt-0"></v-divider></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-0>
            <v-layout wrap justify-center :style="$route.name == 'adminDashboard'
                ? 'background-color: #ffffff'
                : 'background-color: #f6fff9'
              ">
              <v-flex xs12>
                <v-card min-height="100vh" :color="$route.name == 'Dashboard' ? 'transparent' : '#FFFFFF'
                  " flat>
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import SarpaAppHeader from "@/components/Common/appHeadersarpa";
import AppSidebar from "@/components/Common/appSidebar";

export default {
  components: {
    SarpaAppHeader,
    AppSidebar,
  },
  data() {
    return {
      //open state for the sidebar; only used below md, where it overlays
      sideNav: false,
      sarpadashboard: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Sarpa/dashboard",
        },
        // state level snakebite response
        {
          title: "Snake Bite Insights",
          icon: "mdi-chart-timeline-variant",
          path: "/stateDashboard",
        },
        {
          title: "Snake Reports",
          icon: "mdi-file-chart",
          path: "/snakereports",
        },
        {
          title: "Snake Bite Alerts",
          icon: "mdi-bell-alert",
          path: "/snakebiteAlerts",
        },
        {
          title: "Activity Log",
          icon: "mdi-clipboard-text-clock-outline",
          path: "/stateActivityLog",
        },
        {
          title: "Anti-Venom Stock",
          icon: "mdi-medical-bag",
          path: "/stockVenom",
        },
        // {
        //   title: "Statistics ",
        //   icon: "mdi-chart-bar",
        //   path: "/admin/commonanalyticspage",
        // },
        // "Add Snakes" lives as a button inside the Snake List page
        {
          title: "Snake List",
          icon: "mdi-snake",
          path: "/listedSnakes",
        },
        {
          title: "All Users",
          icon: "mdi-account-group",
          path: "/usersList",
        },
        // {
        //   title: "DFO List",
        //   icon: "mdi-account-details",
        //   path: "/dfoList",
        // },
        {
          title: "Control Room ",
          icon: "mdi-file-account",
          path: "/controlRoomList",
        },
        {
          title: "New Rescuers",
          icon: "mdi-account-plus",
          path: "/newrescuerslist",
        },
        {
          title: "New Rescuers(CI REC)",
          icon: "mdi-account-multiple-plus-outline",
          path: "/newrescuerslistcircle",
        },
        {
          title: "Rescuer List",
          icon: "mdi-account-multiple-plus ",
          path: "/allrescuerlist",
        },
        {
          title: "Training List",
          icon: "mdi-format-list-bulleted-triangle",
          path: "/traininglist",
        },
        {
          title: "DMO List",
          icon: "mdi-doctor",
          path: "/alldmolist",
        },
        {
          title: "Emergency Officers",
          icon: "mdi-account-hard-hat",
          path: "/alldistrictlist",
        },
        {
          title: "State Medical Officers",
          icon: "mdi-account-tie-voice",
          path: "/stateMedicalOfficersList",
        },
        {
          title: "Disaster Officers",
          icon: "mdi-shield-account",
          path: "/disasterOfficersList",
        },
        {
          title: "State Disaster Officers",
          icon: "mdi-shield-crown-outline",
          path: "/stateDisasterOfficersList",
        },
        // {
        //   title: "Pending Operations",
        //   icon: "mdi-playlist-remove",
        //   path: "/pendingoperations",
        // },
        // {
        //   title: "Assigned Operations",
        //   icon: "mdi-view-list",
        //   path: "/assignedoperations",
        // },
        // {
        //   title: "Rescued Operations",
        //   icon: "mdi-playlist-plus",
        //   path: "/rescuedoperations",
        // },
        // {
        //   title: "Released Operations",
        //   icon: "mdi-format-list-checks",
        //   path: "/releasedoperations",
        // },
        // {
        //   title: "Approved Operations",
        //   icon: "mdi-playlist-check",
        //   path: "/approvedoperations",
        // },
        // {
        //   title: "Delete Operations",
        //   icon: "mdi-delete-sweep",
        //   path: "/deleteoperations",
        // },
        // {
        //   title: "Snake Bite Cases",
        //   icon: "mdi-hospital-box-outline ",
        //   path: "/snakeBite",
        // },


        // {
        //   title: "Fraud Cases",
        //   icon: "mdi-close-box-multiple",
        //   path: "/fraudcases",
        // },



        {
          title: "Resource Images",
          icon: "mdi-image",
          path: "/imageList",
        },
        {
          title: "Resource Videos",
          icon: "mdi-video",
          path: "/videoList",
        },
        // {
        //   title: "Add Snake Experts",
        //   icon: "mdi-plus",
        //   path: "/addsnakeexperts",
        // },
        // "Add Hospital" lives as a button inside the Hospital List page
        {
          title: "View Hospital",
          icon: "mdi-hospital-building",
          path: "/Viewhospital",
        },
        {
          title: "Anti Venom Details",
          icon: "mdi-hospital",
          path: "/listVenom",
        },
        {
          title: "Victim Details",
          icon: "mdi-hospital-box",
          path: "/victimDetails",
        },
        {
          title: "Identification Help",
          icon: "mdi-help-box-multiple-outline",
          path: "/identificationhelp",
        },
        {
          title: "Reports",
          icon: "mdi-file-excel",
          path: "/excelreport",
        },
        // {
        //   title: "Approve Hospital",
        //   icon: "mdi-check-decagram-outline",
        //   path: "/approvehospital",
        // },
      ],
      right: null,
    };
  },
};
</script>

<style scoped>
/* reserves the column the fixed sidebar occupies from md up */
.sidebar-slot {
  flex: 0 0 0 !important;
  max-width: 0 !important;
  width: 0 !important;
}
@media (min-width: 960px) {
  .sidebar-slot {
    flex: 0 0 280px !important;
    max-width: 280px !important;
    width: 280px !important;
  }
}

.main-content-flex {
  flex: 1 1 auto !important;
  max-width: 100% !important;
  width: 100% !important;
}

@media (min-width: 960px) {
  .main-content-flex {
    max-width: calc(100% - 280px) !important;
    width: calc(100% - 280px) !important;
  }
}
</style>


